
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerEditor()
    export class PoCreditNoteEditors extends Serenity.LookupEditorBase<Serenity.LookupEditorOptions, PoCreditNoteRow>{

        constructor(hidden: JQuery) {
            super(hidden);
        }

        protected getLookupKey() {
            return PoCreditNoteRow.lookupKey;
        }

        // protected getItemText(item, lookup) {
        //     return super.getItemText(item, lookup) + ' [' + item.MbFirstName+']';
        // }
    }
}
